import React, { useState } from 'react';
import { Address, AddressPurpose, Cart } from '@msdyn365-commerce/retail-proxy';
import { IAddressAddItem } from '../../modules/lds-checkout-shipping-address/components/address/address-add';
import { AddressFormat } from '../../modules/lds-delivery/components/address-format';
import {
    IAddressDropdownsData,
    IAddressItem,
    IAddressValidationRule,
    AddressItemDisplayType,
    AddressItemType,
    AddressValidationRuleType
} from '../../modules/lds-delivery/components/address-format.data';
import { AddressMetaData } from '../../modules/lds-delivery/components/address-meta.data';
import { AddressCommon } from '@msdyn365-commerce-modules/address';
import { ILdsDeliveryResources } from '../../modules/lds-delivery/lds-delivery.props.autogenerated';
import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/core';
import classname from 'classnames';
import { AddressType } from '../../modules/lds-delivery/components/address-module.data';
// import countryRegions from '../../modules/lds-checkout-shipping-address/mocks/country-regions';
import { ICartLineWithProduct } from '../../modules/lds-delivery/lds-delivery';
import { updateLineDeliverySpecifications } from './cart-line-utilities';

import { validateSuggestAddressAsync } from '../../actions/DataActionExtension.g';
import { ICartState } from '@msdyn365-commerce/global-state';
import { format } from '@msdyn365-commerce-modules/utilities';

import { stateCheckList, stateCheckListKo } from './state-address-utilities';

interface Option {
    value: string;
    label: string;
    key: string;
}

export const getAddressItems = (
    inputAddress: Address,
    dropdownDisplayData: IAddressDropdownsData,
    setInputAddress: (address: Address) => void,
    addressPurposes: AddressPurpose[],
    resources: ILdsDeliveryResources,
    context: ICoreContext,
    telemetry: ITelemetry,
    cart: any,
    setCountryStates?: any,
    countryRegions?: any,
    setRequiredInputs?: any,
    requiredInputs?: any,
    setError?: any
): IAddressAddItem[] => {
    const addressType = AddressType.Shipping;
    const _getAddressFormatExcludeList = (): AddressItemType[] => {
        const addressFormatExcludeList: AddressItemType[] = [];

        addressFormatExcludeList.push(AddressItemType.AddressTypeValue);

        addressFormatExcludeList.push(AddressItemType.IsPrimary);

        return addressFormatExcludeList;
    };

    const getRequriedAttribute = (validationRules?: IAddressValidationRule[]): object => {
        const requriedRule = (validationRules || []).find(validationRule => {
            return validationRule.type === AddressValidationRuleType.Required;
        });

        return requriedRule ? { 'aria-required': true } : {};
    };
    const addressFormat = new AddressFormat(
        countryRegions || [],
        new AddressMetaData({ ...resources }, _getAddressFormatExcludeList()),
        addressPurposes || []
    );
    const countryExtension = cart.result.cart.ExtensionProperties.filter((property: any) => {
        return property.Key === 'Country';
    });
    const userCountry = countryExtension[0].Value.StringValue;

    const addressCommon = new AddressCommon(context, resources, telemetry);
    const market = context.request.channel?.ChannelCountryRegionISOCode;
    const countryRegionId = addressCommon.getDefaultCountryRegionId(userCountry || market, countryRegions || [], userCountry || market);
    const addressItem = addressFormat.getAddressFormat(
        inputAddress.ThreeLetterISORegionName ? inputAddress.ThreeLetterISORegionName : countryRegionId
    );

    const onSetAddress = (name: string, value: string | boolean) => {
        setInputAddress({ ...inputAddress, [name]: value });
    };

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.type === 'checkbox') {
            onSetAddress(event.target.name, event.target.checked);
        } else {
            const value = (event.target.value || '').replace(new RegExp('[<>]', 'gi'), '');
            onSetAddress(event.target.name, value);
        }
    };

    const onDropdownChange = (inputValue: any): void => {
        const values = inputValue.target.value.split(',');
        const key = values[1] || 'key';
        const value = values[0] || 'value';
        if (key === 'ThreeLetterISORegionName') {
            setCountryStates(value);
        }
        setInputAddress({ ...inputAddress, [key]: value });
    };

    const twoStreetsAddressFormat: IAddressItem[] = [];

    addressItem.map((addressFormatItem, index) => {
        if (addressFormatItem.name === 'State' && countryRegionId === 'KOR') {
            addressFormatItem.label = resources.addressMunicipalityLabel;
        }
        if (addressFormatItem.name === 'City' && countryRegionId === 'AUS') {
            addressFormatItem.label = resources.addressSuburbLabel;
        }
        if (addressFormatItem.name === 'Street') {
            let validationRules1: IAddressValidationRule[] = [];
            let validationRules2: IAddressValidationRule[] = [];
            if (addressFormatItem.validationRules) {
                validationRules1 = [...addressFormatItem.validationRules];
                validationRules2 = [...addressFormatItem.validationRules];

                validationRules1[0].message = 'Street 1 is required';
                validationRules2.shift();
            }

            const street1 = {
                ...addressFormatItem,
                name: 'Street',
                label: resources.addressStreetLabel1,
                maxLength: 30,
                validationRules: validationRules1
            };
            const street2 = {
                ...addressFormatItem,
                name: 'Street_2',
                label: resources.addressStreetLabel2,
                maxLength: 30,
                validationRules: validationRules2
            };
            twoStreetsAddressFormat.push(street1);
            twoStreetsAddressFormat.push(street2);
        } else {
            twoStreetsAddressFormat.push(addressFormatItem);
        }
    });

    const requiredFormInputs = twoStreetsAddressFormat.filter(x => {
        return x.validationRules && x.validationRules[0].type === 'Required' && x.name !== 'ThreeLetterISORegionName';
    });

    if (requiredInputs === undefined && setRequiredInputs) {
        setRequiredInputs(requiredFormInputs);
    }

    return twoStreetsAddressFormat.map((addressFormatItem, index) => {
        const elementId = `${addressType.toLowerCase()}_address${addressFormatItem.name.toLowerCase()}`;
        const errorMessage = '';
        const className = classname('msc-address-form__item', `msc-address-form__item-${addressFormatItem.name.toLowerCase()}`, {
            'msc-address-form__item-newline': addressFormatItem.isNewLine,
            'address-form__item-invalid': errorMessage
        });
        const addressItemStyle: React.CSSProperties = {
            margin: '16px 18px'
        };

        let input;

        const textInputStyle: React.CSSProperties = {
            width: '100%',
            border: '1px solid #878A8C',
            boxSizing: 'border-box',
            borderRadius: '2px',
            margin: '8px 0px',
            lineHeight: '22px',
            padding: '8px',
            fontSize: '16px',
            fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
            fontStyle: 'normal'
        };
        const textInputStyleInvalid: React.CSSProperties = {
            width: '100%',
            border: '1px solid red',
            boxSizing: 'border-box',
            borderRadius: '2px',
            margin: '8px 0px',
            lineHeight: '22px',
            padding: '8px',
            fontSize: '16px',
            fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
            fontStyle: 'normal'
        };

        const labelStyle: React.CSSProperties = {
            fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            marginLeft: '8px'
        };
        const [invalidError, setInavlidError] = useState('');
        // const [firstBlur, setFirstBlur] = useState(true);

        const inputRequired = getRequriedAttribute(addressFormatItem.validationRules);
        const inputRequiredValues = Object.values(inputRequired);
        const isInputRequired = inputRequiredValues[0] === true ? true : false;
        const inputChanged = (e: any) => {
            const phoneCheck = /^[\+]?[(]?[0-9]{0,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
            const nameCheck = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
            const emojiNameCheck = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

            if (!e.target.value && isInputRequired) {
                const label = addressFormatItem.label.split('*');
                const inputText =
                    addressFormatItem.type === 1 && resources.addressZipCodeRequiredErrorMessage
                        ? resources.addressZipCodeRequiredErrorMessage
                        : label[0];
                const errorText = format(resources.addressDefaultRequiredErrorMessage, inputText);
                setInavlidError(errorText);
                setError(true);
            } else if (addressFormatItem.type === 1002 && e.target.value) {
                if (!phoneCheck.test(e.target.value)) {
                    setError(true);
                    setInavlidError(resources.addressPhoneFormatErrorMessage ? resources.addressPhoneFormatErrorMessage : '');
                } else {
                    // setError(false);
                    setInavlidError('');
                }
            } else if (addressFormatItem.type === 1001 && e.target.value) {
                if (nameCheck.test(e.target.value) || emojiNameCheck.test(e.target.value)) {
                    const errorText = format(resources.addressDefaultInvalidErrorMessage, addressFormatItem.name);
                    setError(true);
                    setInavlidError(errorText);
                } else {
                    // setError(false);
                    setInavlidError('');
                }
            } else {
                setInavlidError('');
            }
        };

        const dropdownValueCheck = (inputValue: any): void => {
            const values = inputValue.target.value.split(',');
            const key = values[1] || 'key';
            const value = values[0] || 'value';
            const dropdownValue = { ...inputAddress, [key]: value };
            if (!dropdownValue.State) {
                setInavlidError(`${addressFormatItem.name} is required`);
            } else {
                setInavlidError('');
            }
        };

        if (addressFormatItem.displayType === AddressItemDisplayType.Input) {
            input = (
                <>
                    <input
                        {...{
                            id: elementId,
                            name: addressFormatItem.name,
                            className: 'msc-address-form',
                            type: 'text',
                            autoFocus: index === 0,
                            value: inputAddress[addressFormatItem.name],
                            maxLength: addressFormatItem.maxLength,
                            onChange: onInputChange,
                            additionalAddributes: getRequriedAttribute(addressFormatItem.validationRules),
                            onBlur: inputChanged
                        }}
                        style={invalidError.length <= 1 ? textInputStyle : textInputStyleInvalid}
                    />
                </>
            );
        } else if (addressFormatItem.displayType === AddressItemDisplayType.Checkbox) {
            input = (
                <input
                    {...{
                        id: elementId,
                        name: addressFormatItem.name,
                        className: 'msc-address-form',
                        type: 'checkbox',
                        autoFocus: index === 0,
                        isChecked: inputAddress[addressFormatItem.name],
                        onChange: onInputChange,
                        additionalAddributes: getRequriedAttribute(addressFormatItem.validationRules)
                    }}
                />
            );
        } else {
            const displayData = dropdownDisplayData[addressFormatItem.name];
            // const prefilledAddressDropdownData = addressFormat.getPrefilledAddressDropdownData(
            //     resources.addressStateDefaultSelectionText,
            //     newStates || []
            // );

            const options: Option[] = displayData
                .filter(x => x.key !== '')
                .map(data => {
                    return {
                        key: addressFormatItem.name,
                        value: (data.key as string) || '',
                        label: (data.value as string) || ''
                    };
                });
            const selectedValue = {
                key: addressFormatItem.name,
                label: inputAddress[addressFormatItem.name],
                value: inputAddress[addressFormatItem.name]
            };

            let disableDropdown = false;
            if (addressFormatItem.type === AddressItemType.ThreeLetterISORegionName) {
                selectedValue.key = addressFormatItem.name;
                selectedValue.label = displayData.find(x => x.key === countryRegionId)?.value; // selectedValue.value || countryRegionId;
                selectedValue.value = countryRegionId;

                if (inputAddress.ThreeLetterISORegionName !== countryRegionId) {
                    setInputAddress({ ...inputAddress, [selectedValue.key]: selectedValue.value });
                }

                disableDropdown = true;
            }

            if (addressFormatItem.type === AddressItemType.AddressTypeValue) {
                selectedValue.key = addressFormatItem.name;
                selectedValue.label = selectedValue.value || 6;
                selectedValue.value = selectedValue.value || 6;
            }
            let filteredOptions;

            if (countryRegionId && countryRegionId === 'KOR' && addressFormatItem.name === 'State' && context.request.locale !== 'en-US') {
                filteredOptions = options.filter(option => {
                    return stateCheckListKo.some(item => item.label === option.label && item.value === option.value);
                });
            } else if (
                countryRegionId &&
                countryRegionId === 'KOR' &&
                addressFormatItem.name === 'State' &&
                context.request.locale === 'en-US'
            ) {
                filteredOptions = options.filter(option => {
                    return stateCheckList.some(item => item.label === option.label && item.value === option.value);
                });
            }

            input = (
                <>
                    <select
                        style={{ width: '100%', height: '40px', border: invalidError.length <= 1 ? '' : '1px solid red' }}
                        onChange={chosenOption => {
                            onDropdownChange(chosenOption);
                            dropdownValueCheck(chosenOption);
                        }}
                        disabled={disableDropdown}
                    >
                        <option value='' disabled selected></option>
                        {countryRegionId === 'KOR' && filteredOptions && addressFormatItem.name === 'State'
                            ? filteredOptions.map(opt => {
                                  return (
                                      <option
                                          value={[opt.value, opt.key]}
                                          key={opt.key}
                                          label={opt.label}
                                          style={{ fontSize: '18px' }}
                                          selected={selectedValue.value === opt.value ? true : false}
                                      >
                                          {opt.label}
                                      </option>
                                  );
                              })
                            : options.map(opt => {
                                  return (
                                      <option
                                          value={[opt.value, opt.key]}
                                          key={opt.key}
                                          label={opt.label}
                                          style={{ fontSize: '18px' }}
                                          selected={selectedValue.value === opt.value ? true : false}
                                      >
                                          {opt.label}
                                      </option>
                                  );
                              })}
                    </select>
                </>
            );
        }

        return {
            key: addressFormatItem.name,
            AddressItem: { className, id: `${elementId}_container`, style: addressItemStyle },
            label: <div style={labelStyle}>{addressFormatItem.label}</div>,
            alert: <small>{invalidError}</small>,
            input
        };
    });
};

export const getSmartyStreetAddress = async (context: ICoreContext, inputAddress: any) => {
    const ctx = { callerContext: context.actionContext };

    inputAddress.AddressTypeValue = 2;
    // Call SmartyStreets here.
    const smartyStreetValidation = await validateSuggestAddressAsync(
        ctx,
        inputAddress.Street || '',
        inputAddress.City || '',
        inputAddress.State || '',
        inputAddress.ZipCode || '',
        inputAddress.ThreeLetterISORegionName || '',
        inputAddress.DistrictName || '',
        inputAddress.Street_2 || ''
    ).catch((err: any) => {
        console.log(err);
    });

    return smartyStreetValidation;
};

export const submitAddress = async (
    context: ICoreContext,
    resources: ILdsDeliveryResources,
    telemetry: ITelemetry,
    inputAddress: Address,
    customerAddresses: Address[],
    cartId: string,
    deliveryGroup: ICartLineWithProduct[],
    addAddressToAccount: boolean,
    countryRegionId: string,
    config: any,
    cart?: ICartState
): Promise<Cart> => {
    const ctx = { callerContext: context.actionContext };

    inputAddress.AddressTypeValue = 2;
    inputAddress.ThreeLetterISORegionName ? null : (inputAddress.ThreeLetterISORegionName = countryRegionId);

    const addressCommon = new AddressCommon(context, resources, telemetry);
    if (addressCommon.isAuthenticatedFlow() && !customerAddresses.includes(inputAddress) && addAddressToAccount) {
        await addressCommon.addCustomerAddress(inputAddress || {});
    }
    const lineDeliverySpecifications = deliveryGroup.map(item => {
        // const isSubscription = item.cartLine.ExtensionProperties?.find(x => x.Key === 'isSubscription')?.Value?.BooleanValue || false;
        if (countryRegionId === 'USA' || countryRegionId === 'CAN') {
            inputAddress.TaxGroup = 'Vertex';
        } else if (inputAddress.TaxGroup === 'Vertex' && countryRegionId !== 'USA' && countryRegionId !== 'CAN') {
            delete inputAddress.TaxGroup;
        }

        return {
            LineId: item.cartLine.LineId,
            DeliverySpecification: {
                DeliveryAddress: inputAddress,
                DeliveryModeId: config.deliveryMode,
                DeliveryPreferenceTypeValue: 1
            }
        };
    });

    return updateLineDeliverySpecifications(ctx, cartId, lineDeliverySpecifications);
};
